import { ActionTree, ActionContext } from 'vuex';

import { subsClient } from '@/http-client';
import { camelToSnake, snakeToCamel } from '@/utils';

import { RootStateI } from '../state';
import { InvoicesStateI } from './state';

export const actions: ActionTree<InvoicesStateI, RootStateI> = {
  async getall(
    context: ActionContext<InvoicesStateI, RootStateI>,
    payload: string,
  ): Promise<void> {
    const { data } = await subsClient.get('/api/invoices/getall');
    context.commit('setInvoices', snakeToCamel(data));
  },
  async getbyid(
    context: ActionContext<InvoicesStateI, RootStateI>,
    payload: string,
  ): Promise<void> {
    const { data } = await subsClient.get(`/api/invoices/get/${payload}`);
    const {
      invoice,
      payment,
      plan,
      service,
    } = snakeToCamel(data);
    context.commit('setInvoice', invoice);
    context.commit('plans/setPlan', plan, { root: true });
    context.commit('services/setService', service, { root: true });
    context.commit('payments/setPayment', payment, { root: true });
  },
};
